import type { Core } from '@strapi/types';

import { createContext } from 'react';

export const StrapiUiContext = createContext<Core.Helpers.Controllers.GetResponseBody<'api::soc-filter.soc-filter'> | undefined>(undefined);
